/**
 * Hook useFormatDate
 * Devuelve una función que formatea fechas con el idioma activo de i18next
 * (ver `i18n/formatDate`). Al cambiar de idioma el componente se vuelve a
 * renderizar porque `useTranslation` está suscrito al cambio.
 */

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../i18n/formatDate';

/**
 * @returns {(dateString: string) => string} Función `(fecha) => textoLocalizado`
 */
const useFormatDate = () => {
  const { i18n } = useTranslation();
  const language = i18n.language;
  return useCallback((dateString) => formatDate(dateString, language), [language]);
};

export default useFormatDate;
